import React, { Component, Suspense } from 'react';
import Page from '../../components/Page';
import { Link, Redirect } from 'react-router-dom';
import { get, post } from '../../util/api';
import { Header, Segment, Breadcrumb, Icon, Checkbox, Form, Button, Modal, Image, Dropdown, Progress, Message } from 'semantic-ui-react';
//import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import ReactImageMagnify from 'react-image-magnify';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import { cacheImage, generateShapes } from './layout';

// eslint-disable-next-line
import styled from 'styled-components/macro';

// Renge özel alanlar diğer renklere kopyalanmaz.
const EXCLUDED_APPLY_FIELDS = ['color', 'code', 'barcode'];
// Export üretimi uzun sürebiliyor; gateway isteği kesse bile sunucu işi bitiriyor,
// bu yüzden istek başına uzun timeout + tekrar deneme uyguluyoruz.
const EXPORT_TIMEOUT = 180000;
const EXPORT_RETRY = 3;
const EXPORT_RETRY_WAIT = 4000;

function wait(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

function createHash(obj) {
	if (obj && !obj._hash) obj._hash = _.deburr(obj.name).toLowerCase().trim();
}

function urltimer() {
	return '?t=' + Math.floor(new Date().getTime() / 60000);
}

const Editor = React.lazy(() => import('./editor'));

function Magnifier(props) {
	let { barcode_img, selected_zoom_img } = props;

	let data = React.useMemo(() => {
		let sizes = (barcode_img && barcode_img.image.__probe) || { width: 3000, height: 3000 };
		let ratio = sizes.width > 3000 ? 3 : 1;
		return {
			smallImage: {
				alt: 'barcode',
				src: selected_zoom_img.replace('wg.dialogtab.com/', 'wg.dialogtab.com/proxy/insecure/q:40/plain/local:///') + urltimer(),
				width: 400 * (sizes.width / sizes.height || 1.5),
				height: 400,
			},
			largeImage: {
				src: selected_zoom_img.replace('wg.dialogtab.com/', 'wg.dialogtab.com/proxy/insecure/q:40/plain/local:///') + urltimer(),
				width: sizes.width / ratio,
				height: sizes.height / ratio,
			},
			enlargedImageContainerDimensions: {
				width: 400,
				height: 400,
			},
		};
	}, [barcode_img, selected_zoom_img]);

	return <ReactImageMagnify {...data} />;
}

class Folder extends Component {
	state = {
		exportdata: {},
		loading: true,
		wait: false,
	};

	editor = React.createRef();

	async getData() {
		let { file, subfolder } = this.props.match.params;
		let data = await get('/shop/schema/list');
		let kolaj = await post('/shop/kolaj/get/' + file, {});
		let result = kolaj.data.result;
		let colors = await post('/shop/kolaj/listColor', {
			subfolder_id: subfolder,
			kolaj_name: (result && result.data && result.data.kolaj_name) || '',
			code: (result && result.data && result.data.kolaj_editor && result.data.kolaj_editor.text_data && result.data.kolaj_editor.text_data.code) || '',
		});
		// route param string, kolaj id number geliyor: duzenlenen kolaj listeden mutlaka cikarilmali
		let otherColors = _.filter(colors.data.result, (it) => String(it.id) !== String(file));
		if (!result) {
			return this.setState({ loading: false, error: true });
		}
		let selected_images =
			_.map(result.data.images, (it) => {
				let name = it && it.split('/');
				name = name && name[name.length - 1];
				return { path: it, name, checked: true };
			}) || result.data.selected_images;
		let kolaj_config = result.data.kolaj_editor && result.data.kolaj_editor.text_data;
		let template_id = result.data.kolaj_editor && result.data.kolaj_editor.template;
		let template_data = data.result;
		let selectedTemplate = (template_id && _.find(template_data, { id: template_id })) || data.result[0];
		let schemas_filtered = _.orderBy(
			_.filter(template_data, (it) => it === selectedTemplate || (it.data && !it.data.hidden)),
			(it) => it.data && (it.data.default || it.data.force)
		);

		let template_dropdown = _.map(schemas_filtered, (it) => ({ text: it.data.name, value: it.id }));

		let refined_images = result.data.refined_images;
		let barcode_img = refined_images && _.find(refined_images, { has_barcode: true });
		let selected_zoom_img;
		if (barcode_img) {
			selected_zoom_img = barcode_img.image.__image;
		} else {
			selected_zoom_img = _.last(result.data.images);
		}
		let zoom_images = _.map(result.data.images, (it) => ({
			text: it.replace(/.*_/, ''),
			value: encodeURI(it),
		}));
		if (data.brands) _.each(data.brands, createHash);
		this.setState({
			data: result,
			brands: data.brands,
			selected_images,
			loading: false,
			folder_data: kolaj.data.result.folder,
			subfolder_data: kolaj.data.result.subfolder,
			kolaj_config: kolaj_config || { price: '0' },
			initial_kolaj_config: _.cloneDeep(kolaj_config || { price: '0' }),
			initial_template_id: selectedTemplate.id,
			refined_images,
			barcode_img,
			selected_zoom_img,
			template_data,
			template_dropdown,
			selectedTemplateId: selectedTemplate.id,
			selectedTemplate: selectedTemplate,
			zoom_images,
			otherColors,
		});
	}
	componentDidMount() {
		this.getData();
	}
	handleChangeArray(i) {
		let { selected_images } = this.state;
		this.setState({
			selected_images: selected_images.map((it, _i) => {
				if (i === _i) it.checked = !it.checked;
				return it;
			}),
		});
	}
	handleChangeJSON(obj) {
		this.setState({ wait: true });
		let { selectedTemplate } = this.state;

		if (!obj.error) {
			let temp = {};
			_.assignIn(temp, selectedTemplate, { id: (selectedTemplate.id || 0) + 1, data: obj.jsObject });
			this.setState({ temp_template: temp });
		}
		setTimeout(() => {
			this.setState({ wait: false });
		}, 1000);
	}
	handleUpdateJson() {
		let { temp_template } = this.state;
		if (temp_template) this.setState({ selectedTemplate: temp_template, selectedTemplateId: temp_template.id });
	}
	onDragEnd = (result) => {
		//console.log(result);
		let from = result.source && result.source.index;
		let to = result.destination && result.destination.index;
		if ((to === 0 || to) && from !== to) {
			let { selected_images } = this.state;
			selected_images.splice(to, 0, selected_images.splice(from, 1)[0]);
			this.setState({
				selected_images: selected_images.map((it) => it),
			});
		}
		//if ((to === 0 || to) && from !== to) this.props.helper.move(from, to);
	};

	handleChange = (e, { name, value }) => {
		let { kolaj_config } = this.state;
		kolaj_config[name] = value;
		this.setState({ kolaj_config });
	};
	// Bu oturumda değiştirilen panel alanları + şablon değişikliği
	getApplyPayload() {
		let { kolaj_config = {}, initial_kolaj_config = {}, selectedTemplate, selectedTemplateId, initial_template_id } = this.state;
		let keys = _.uniq(_.map((selectedTemplate && selectedTemplate.data && selectedTemplate.data.panel) || [], 'keyword'));
		let values = {};
		_.each(keys, (key) => {
			if (_.includes(EXCLUDED_APPLY_FIELDS, key)) return;
			let now = kolaj_config[key];
			let before = initial_kolaj_config[key];
			if ((now || '') + '' !== (before || '') + '') values[key] = now;
		});
		return { values, template_changed: selectedTemplateId !== initial_template_id };
	}
	openApplyModal = () => {
		let { otherColors } = this.state;
		this.setState({
			openApplyModal: true,
			apply_selected: _.map(otherColors, (it) => it.id),
			apply_results: [],
			apply_done: false,
			apply_progress: null,
			apply_preview: null,
			apply_error: null,
		});
	};
	closeApplyModal = () => {
		if (this.state.applying) return;
		let refresh = this.state.apply_done;
		this.setState({ openApplyModal: false, apply_done: false, apply_progress: null, apply_results: [], apply_preview: null, apply_error: null });
		if (refresh) this.getData();
	};
	handleApplySelectAll = () => {
		let { otherColors, apply_selected = [] } = this.state;
		let all = _.map(otherColors, (it) => it.id);
		this.setState({ apply_selected: apply_selected.length === all.length ? [] : all });
	};
	handleApplySelected = (id) => {
		let { apply_selected = [] } = this.state;
		if (_.includes(apply_selected, id)) apply_selected = _.without(apply_selected, id);
		else apply_selected = apply_selected.concat([id]);
		this.setState({ apply_selected });
	};
	// Export uret. Zaman asimi / gecici hata durumunda tekrar dener; sunucu tarafi
	// hash kontrollu oldugu icin ayni export ikinci kez uretilmez, hazirsa aninda doner.
	async generateExport(id) {
		let last_error;
		for (let i = 0; i < EXPORT_RETRY; i++) {
			try {
				let final = await get(`/shop/kolaj/final/${id}`, null, { timeout: EXPORT_TIMEOUT });
				if (!final || final.success === false) throw Error((final && final.message) || 'Export alınamadı');
				let url = _.get(final, 'result.data.export.url');
				if (!url) throw Error('Export adresi boş döndü');
				return url;
			} catch (error) {
				last_error = error;
				console.error('export hatası', id, error);
				if (i < EXPORT_RETRY - 1) await wait(EXPORT_RETRY_WAIT);
			}
		}
		throw Error(`Export alınamadı (${EXPORT_RETRY} deneme): ${last_error && last_error.message}`);
	}
	// Kaydet + export al + onayla (verified)
	async publishKolaj(id, kolaj_editor, selected_images) {
		await post('/shop/kolaj/save', { id, data: { kolaj_editor, selected_images }, status: 'done' });
		let url = await this.generateExport(id);
		await post('/shop/kolaj/save', { id, data: {}, status: 'verified' });
		return url;
	}
	async applyToColor(target, payload) {
		let { selectedTemplate, selectedTemplateId } = this.state;
		let response = await post('/shop/kolaj/get/' + target.id, {});
		let kolaj = response && response.data && response.data.result;
		if (!kolaj || !kolaj.data) throw Error('Kolaj bulunamadı');
		let k_data = kolaj.data;
		let old_editor = k_data.kolaj_editor || {};
		let text_data = _.assignIn({}, old_editor.text_data, payload.values);
		let selected_images =
			(k_data.selected_images && k_data.selected_images.length && k_data.selected_images) ||
			_.map(k_data.images || [], (it) => ({ path: it, name: _.last(it.split('/')), checked: true }));
		let list = _.map(
			_.filter(selected_images, (it) => it.checked),
			(it) => it.path
		);
		let sema = selectedTemplate.data;
		let positions;
		if (old_editor.data && old_editor.data.length && old_editor.template === selectedTemplateId) {
			// Şablon zaten aynı: elle yapılmış kırpmaları bozma, sadece metinleri güncelle
			positions = old_editor.data;
		} else {
			let images = await Promise.all((sema.images ? _.take(list, sema.images.length) : list).map(cacheImage));
			positions = generateShapes(images, sema, list);
		}
		let kolaj_editor = { sema, data: positions, template: selectedTemplateId, text_data };
		return this.publishKolaj(target.id, kolaj_editor, selected_images);
	}
	// 1. adim: ekrandaki kolaji kaydet, export'unu al ve onaya sun
	async startApply() {
		let { data, selected_images } = this.state;
		this.setState({ apply_preview_loading: true, apply_error: null });
		try {
			let kolaj_editor = this.editor.current && this.editor.current.save();
			if (!kolaj_editor) throw Error('Editör hazır değil');
			await post('/shop/kolaj/save', { id: data.id, data: { kolaj_editor, selected_images }, status: 'done' });
			let url = await this.generateExport(data.id);
			this.setState({ apply_preview: url, apply_preview_loading: false });
		} catch (error) {
			console.error(error);
			this.setState({ apply_preview_loading: false, apply_error: error.message });
		}
	}
	// 2. adim: onizleme onaylandi -> ekrandaki kolaji onayla, sonra secili renklere uygula
	applyToAllColors() {
		let { otherColors, apply_selected = [] } = this.state;
		let targets = _.filter(otherColors, (it) => _.includes(apply_selected, it.id));
		return this.runApply(targets, true);
	}
	// Sadece hata alanlari tekrar dener; basarililar atlanir
	retryFailed() {
		let { otherColors, apply_results = [], data } = this.state;
		let failed_ids = _.map(
			_.filter(apply_results, (it) => !it.success),
			'id'
		);
		let targets = _.filter(otherColors, (it) => _.includes(failed_ids, it.id));
		return this.runApply(targets, _.includes(failed_ids, data.id));
	}
	async runApply(targets, include_current) {
		let { data } = this.state;
		let payload = this.getApplyPayload();
		// onceki turdan basarililari koru, tekrar denenecekleri listeden cikar
		let retry_ids = _.map(targets, (it) => it.id).concat(include_current ? [data.id] : []);
		let results = _.filter(this.state.apply_results || [], (it) => it.success && !_.includes(retry_ids, it.id));
		let total = targets.length + (include_current ? 1 : 0);
		let done = 0;
		this.setLeaveGuard(true);
		this.setState({ applying: true, apply_done: false, apply_results: results.slice(), apply_progress: { done, total } });

		// Ekrandaki kolaj startApply'da kaydedilip export'u alinmisti; burada sadece onaylaniyor
		if (include_current) {
			let current_name = data.data.kolaj_name;
			try {
				await post('/shop/kolaj/save', { id: data.id, data: {}, status: 'verified' });
				results.push({ id: data.id, name: current_name, success: true });
			} catch (error) {
				console.error(error);
				results.push({ id: data.id, name: current_name, success: false, error: error.message });
			}
			done++;
			this.setState({ apply_results: results.slice(), apply_progress: { done, total } });
		}

		for (let i = 0; i < targets.length; i++) {
			let target = targets[i];
			let name = _.get(target, 'data.kolaj_editor.text_data.color') || _.get(target, 'data.kolaj_name') || target.id;
			try {
				await this.applyToColor(target, payload);
				results.push({ id: target.id, name, success: true });
			} catch (error) {
				console.error(error);
				results.push({ id: target.id, name, success: false, error: error.message });
			}
			done++;
			this.setState({ apply_results: results.slice(), apply_progress: { done, total } });
		}

		this.setLeaveGuard(false);
		this.setState({
			applying: false,
			apply_done: true,
			initial_kolaj_config: _.cloneDeep(this.state.kolaj_config),
			initial_template_id: this.state.selectedTemplateId,
		});
	}
	setLeaveGuard(on) {
		window.onbeforeunload = on ? () => 'Toplu uygulama sürüyor, sayfadan ayrılırsanız kalan renkler işlenmez.' : null;
	}
	componentWillUnmount() {
		this.setLeaveGuard(false);
	}
	async saveData(data, publish) {
		let kolaj_editor = this.editor.current && this.editor.current.save();
		if (!kolaj_editor) return;
		this.setState({ btnLoading: true });
		let body = { id: data.id, data: { kolaj_editor, selected_images: this.state.selected_images } };
		if (publish) {
			body.status = 'done';
		}
		console.log('body ', body);
		await post('/shop/kolaj/save', body).then(() => {
			if (!publish) this.setState({ btnLoading: false });
		});
		if (publish) {
			await get(`/shop/kolaj/final/${data.id}`).then((response) => {
				let exportdata = response.result.data.export;
				this.setState({ openExportModal: true, btnLoading: false, exportdata });
			});
		}
	}

	async exportData(data) {
		this.setState({ modalButton: true });
		let body = { id: data.id, data: {}, status: 'verified' };
		await post('/shop/kolaj/save', body).then(() => {
			this.setState({ openExportModal: false, modalButton: false });
		});
	}
	handleChangeTemplate = (e, { name, value }) => {
		let { template_data, selectedTemplate } = this.state;
		selectedTemplate = _.find(template_data, { id: value });
		this.setState({ [name]: value, selectedTemplate, selectedTemplateId: value });
	};
	render() {
		const { t } = this.props;
		let {
			loading,
			data,
			folder_data,
			subfolder_data,
			selected_images,
			kolaj_config,
			btnLoading,
			//template_data,
			template_dropdown,
			selectedTemplate,
			selectedTemplateId,
			openExportModal,
			exportdata,
			selected_zoom_img,
			barcode_img,
			refined_images,
			zoom_images,
			error,
			brands,
			otherColors,
			openApplyModal,
			apply_selected = [],
			apply_results = [],
			apply_progress,
			applying,
			apply_done,
			apply_preview,
			apply_preview_loading,
			apply_error,
		} = this.state;
		let { folder, subfolder } = this.props.match.params;
		if (loading)
			return (
				<Page
					header={
						<Breadcrumb size="big">
							<Breadcrumb.Section as={Link} to={`/whatsapp-shop`}>
								<Icon name="block layout" />
								Kolaj
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon={{ name: 'asterisk', loading: true }} />
						</Breadcrumb>
					}
				>
					<Page.Loader></Page.Loader>
				</Page>
			);
		if (error) {
			return <Redirect to="/whatsapp-shop" />;
		}
		let kolaj_editor = data.data.kolaj_editor;
		// console.log('selectedTemplateId', this.state);
		let first_result = data.data.first_result;
		let isAll = window.location.search && /all=true/.test(window.location.search);
		let apply_payload = this.getApplyPayload();
		apply_payload.has_changes = apply_payload.template_changed || !_.isEmpty(apply_payload.values);
		return (
			<Page
				header={
					<Breadcrumb size="big">
						<Breadcrumb.Section as={Link} to={`/whatsapp-shop`}>
							<Icon name="block layout" />
							Kolaj
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon="right chevron" />

						<Breadcrumb.Section as={Link} to={`/whatsapp-shop/${folder}`}>
							{folder_data.data.name}
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon="right chevron" />

						<Breadcrumb.Section as={Link} to={`/whatsapp-shop/${folder}/${subfolder}`}>
							{subfolder_data.data.name}
						</Breadcrumb.Section>

						<Breadcrumb.Divider icon="right chevron" />

						<Breadcrumb.Section>{data.data.kolaj_name}</Breadcrumb.Section>
					</Breadcrumb>
				}
				flex
			>
				<div className="konva-editor-wrap">
					<div className="ke-info">
						<Segment>
							<div style={{ display: 'flex' }}>
								<div>
									<Button basic labelPosition="left" color="grey" icon as={Link} to={`/whatsapp-shop/${folder}/${isAll ? 'all' : subfolder}`}>
										<Icon name="arrow left"></Icon>
										{t('back')}
									</Button>
								</div>
								<Header style={{ margin: '7px 7px 0px 10px', maxWidth: '300px' }}>
									<p style={{ wordBreak: 'break-word' }}>{data.data.kolaj_name}</p>
								</Header>
								<div style={{ marginLeft: 'auto' }}>
									<Button loading={btnLoading} primary onClick={() => this.saveData(data, false)}>
										Kaydet
									</Button>
									<Button loading={btnLoading} positive onClick={() => this.saveData(data, true)}>
										Onaya Gönder
									</Button>
								</div>
							</div>
						</Segment>
						<Segment>
							<Header>Resimler</Header>

							<DragDropContext onDragEnd={this.onDragEnd}>
								<Droppable droppableId="actions" type="list">
									{(provided) => {
										return (
											<div className="files-list" {...provided.droppableProps} ref={provided.innerRef}>
												{_.map(selected_images, (it, i) => {
													return (
														<Draggable key={it.name} draggableId={it.name} index={i}>
															{(provided) => {
																return (
																	<div ref={provided.innerRef} className="action-body" {...provided.draggableProps}>
																		<div {...provided.dragHandleProps}>
																			<Icon name="arrows alternate vertical" size="large"></Icon>
																		</div>
																		<Checkbox checked={it.checked} onChange={() => this.handleChangeArray(i)}></Checkbox>
																		<div alt="img" size="medium" style={{ marginLeft: '10px' }}>
																			{it.name}
																		</div>
																		<a
																			style={{ marginLeft: '10px' }}
																			href={it.path}
																			target="_blank"
																			rel="noopener noreferrer"
																		>
																			<Icon name="external"></Icon>
																		</a>
																	</div>
																);
															}}
														</Draggable>
													);
												})}
												{provided.placeholder}
											</div>
										);
									}}
								</Droppable>
							</DragDropContext>
						</Segment>
						<Segment>
							<Header>Panel</Header>
							<Form className="panel-extra">
								<Form.Field inline>
									<label>Şablon</label>
									<Dropdown options={template_dropdown} selection value={selectedTemplateId} onChange={this.handleChangeTemplate} />
								</Form.Field>
								{_.map(selectedTemplate.data.panel, (it) => {
									let s_value = first_result && first_result[it.keyword];

									if (it.type && it.type.search('_dropdown') != -1 && selectedTemplate.data[it.type]) {
										if (!selectedTemplate[it.type])
											selectedTemplate[it.type] = _.map(selectedTemplate.data[it.type], (it) => ({
												value: it.range,
												text: it.range,
											}));
										return (
											<div className="inline field" key={it.keyword}>
												<label>{it.title}</label>
												<Dropdown
													search
													placeholder={it.default}
													selection
													name={it.keyword}
													value={kolaj_config['' + it.keyword]}
													onChange={this.handleChange}
													options={selectedTemplate[it.type]}
												/>
											</div>
										);
									} else if (it.type === 'brands' && selectedTemplate.data.brands) {
										if (!selectedTemplate.__brands) {
											/* selectedTemplate.__brands = _.map(selectedTemplate.data.brands, (it) => ({
												value: it,
												text: it,
											})); */
										}
										selectedTemplate.__brands = _.map(brands, (it) => ({
											value: it.name,
											text: it.name,
										}));
										return (
											<div className="inline field" key={it.keyword}>
												<label>{it.title}</label>
												<Dropdown
													search
													placeholder={it.default}
													selection
													name={it.keyword}
													value={kolaj_config['' + it.keyword]}
													onChange={this.handleChange}
													options={selectedTemplate.__brands}
												/>
												{first_result && kolaj_config['' + it.keyword] !== s_value ? (
													<Icon
														name="pencil alternate"
														style={{ marginLeft: '22px', marginTop: 'auto', marginBottom: 'auto' }}
													></Icon>
												) : (
													''
												)}
											</div>
										);
									} else
										return (
											<div className="inline field" style={{ display: 'flex' }}>
												<Form.Input
													inline
													key={it.keyword}
													label={it.title}
													placeholder={it.default}
													name={it.keyword}
													value={kolaj_config['' + it.keyword]}
													onChange={this.handleChange}
												/>
												{first_result && kolaj_config['' + it.keyword] !== s_value ? (
													<Icon
														name="pencil alternate"
														style={{ marginLeft: '10px', marginTop: 'auto', marginBottom: 'auto' }}
													></Icon>
												) : (
													''
												)}
											</div>
										);
								})}
							</Form>
						</Segment>
						<div
							css={`
								padding: 0 0 5px 0 !important;
								> div {
									z-index: 1;
									margin: 0 auto;
									> img {
										box-shadow: 0 1px 2px 0 rgb(34 36 38 / 15%);
										border-radius: 0.28571429rem;
										border: 1px solid rgba(34, 36, 38, 0.15);
									}
								}
							`}
						>
							<Dropdown
								selection
								fluid
								options={zoom_images}
								value={selected_zoom_img}
								onChange={(e, { value }) => {
									let barcode_img = refined_images && _.find(refined_images, (it) => it.image && it.image.__image === value);
									this.setState({ barcode_img, selected_zoom_img: value });
								}}
							></Dropdown>
							<Magnifier barcode_img={barcode_img} selected_zoom_img={selected_zoom_img} />
						</div>
						{otherColors && otherColors.length > 0 ? (
							<Segment>
								<div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
									<Header style={{ margin: 0 }}>Diğer Renkler</Header>
									<Button
										primary
										size="tiny"
										style={{ marginLeft: 'auto' }}
										disabled={!apply_payload.has_changes}
										title={apply_payload.has_changes ? '' : 'Önce şablonu veya panel alanlarını değiştirin'}
										onClick={this.openApplyModal}
									>
										Tüm Renklere Uygula ({otherColors.length + 1})
									</Button>
								</div>
								<Image.Group size="small">
									{_.map(otherColors, (it) => (
										<a href={`/whatsapp-shop/${it.folder.id}/${it.subfolder_id}/${it.id}`}>
											<Image src={(it.data.export && it.data.export.url) || it.data.images[0]} />
										</a>
									))}
								</Image.Group>
							</Segment>
						) : null}
					</div>
					<div className="ke-editor">
						<Suspense fallback={<div>Yükleniyor...</div>}>
							<Editor
								editor={this.editor}
								kolaj_config={kolaj_config}
								images={selected_images}
								kolaj_editor={kolaj_editor}
								template={selectedTemplate}
								brands={this.state.brands}
							/>
						</Suspense>
					</div>
					{/debug=true/.test(window.location.search) ? (
						<div>
							<Button disabled={this.state.wait} positive onClick={() => this.handleUpdateJson()}>
								Update
							</Button>
							<JSONInput
								id="a_unique_id"
								placeholder={selectedTemplate.data}
								locale={locale}
								height="720px"
								onChange={(e) => this.handleChangeJSON(e)}
							/>
						</div>
					) : (
						''
					)}
				</div>
				<Modal open={!!openApplyModal} size="small" closeOnDimmerClick={!applying} onClose={() => this.closeApplyModal()}>
					<Modal.Header>
						Tüm Renklere Uygula
						<div style={{ fontSize: '13px', fontWeight: 'normal', color: '#767676', marginTop: '5px' }}>
							Düzenlenen kolaj ve seçili {apply_selected.length} renk — toplam {apply_selected.length + 1} kolaj güncellenecek.
						</div>
					</Modal.Header>
					<Modal.Content scrolling>
						<div
							css={`
								.ac-section + .ac-section {
									margin-top: 26px;
								}
								.ac-head {
									display: flex;
									align-items: baseline;
									margin-bottom: 10px;
								}
								.ac-title {
									font-size: 12px;
									font-weight: 700;
									letter-spacing: 0.05em;
									text-transform: uppercase;
									color: #8f9599;
								}
								.ac-count {
									text-transform: none;
									letter-spacing: 0;
									font-weight: 400;
									color: #b0b5b9;
									margin-left: 6px;
								}
								.ac-link {
									margin-left: auto;
									font-size: 13px;
									color: #2185d0;
									cursor: pointer;
								}
								.ac-box {
									border: 1px solid #e6e8ea;
									border-radius: 6px;
									overflow: hidden;
								}
								.ac-row {
									display: flex;
									align-items: center;
									padding: 11px 14px;
									font-size: 14px;
								}
								.ac-row + .ac-row {
									border-top: 1px solid #f0f1f2;
								}
								.ac-row .icon {
									color: #a3a8ac;
									margin-right: 10px;
								}
								.ac-row b {
									margin-left: auto;
									padding-left: 12px;
									text-align: right;
									word-break: break-word;
								}
								.ac-empty {
									color: #9aa0a4;
									font-style: italic;
								}
								.ac-grid {
									display: grid;
									grid-template-columns: repeat(auto-fill, minmax(108px, 1fr));
									grid-gap: 14px;
								}
								.ac-card {
									position: relative;
									border: 2px solid #e6e8ea;
									border-radius: 8px;
									padding: 8px 8px 6px;
									text-align: center;
									background: #fff;
									cursor: pointer;
									transition:
										border-color 0.15s ease,
										box-shadow 0.15s ease,
										opacity 0.15s ease;
								}
								.ac-card:hover {
									border-color: #c3c9cd;
								}
								.ac-card.is-selected {
									border-color: #2185d0;
									box-shadow: 0 1px 8px rgba(33, 133, 208, 0.16);
								}
								.ac-card.is-off {
									opacity: 0.45;
								}
								.ac-card.is-locked {
									cursor: default;
								}
								.ac-card img {
									width: 100%;
									height: 92px;
									object-fit: contain;
									display: block;
								}
								.ac-name {
									margin-top: 8px;
									font-size: 12px;
									line-height: 1.3;
									color: #3d4144;
									word-break: break-word;
								}
								.ac-badge {
									position: absolute;
									top: -9px;
									right: -9px;
									width: 22px;
									height: 22px;
									border-radius: 50%;
									background: #fff;
									border: 2px solid #d7dbde;
									box-sizing: border-box;
								}
								.ac-badge.is-on {
									background: #2185d0;
									border-color: #2185d0;
								}
								.ac-badge.is-ok {
									background: #21ba45;
									border-color: #21ba45;
								}
								.ac-badge.is-err {
									background: #db2828;
									border-color: #db2828;
								}
								.ac-badge .icon {
									color: #fff;
									font-size: 11px;
									line-height: 18px;
									width: 18px;
									margin: 0;
								}
								.ac-preview {
									text-align: center;
									padding: 14px;
									background: #fafbfc;
									border: 1px solid #e6e8ea;
									border-radius: 6px;
								}
								.ac-preview img {
									max-height: 40vh;
									max-width: 100%;
									width: auto;
									border-radius: 4px;
									border: 1px solid #e6e8ea;
									background: #fff;
								}
								.ac-note {
									margin-top: 22px;
									display: flex;
									align-items: flex-start;
									font-size: 13px;
									line-height: 1.5;
									color: #767676;
								}
								.ac-note .icon {
									margin-right: 8px;
									color: #a3a8ac;
								}
								.ac-progress {
									margin-top: 22px;
								}
								.ac-progress .ui.progress {
									margin: 0;
								}
							`}
						>
							<div className="ac-section">
								<div className="ac-head">
									<div className="ac-title">Uygulanacak Değişiklikler</div>
								</div>
								<div className="ac-box">
									{apply_payload.template_changed ? (
										<div className="ac-row">
											<Icon name="image outline" />
											Şablon<b>{selectedTemplate.data.name}</b>
										</div>
									) : null}
									{_.map(apply_payload.values, (value, key) => {
										let field = _.find(_.get(selectedTemplate, 'data.panel'), { keyword: key });
										return (
											<div className="ac-row" key={key}>
												<Icon name="pencil alternate" />
												{(field && field.title) || key}
												<b>{value || '-'}</b>
											</div>
										);
									})}
									{!apply_payload.has_changes ? (
										<div className="ac-row ac-empty">Değişiklik yok — önce şablonu ya da panel alanlarını değiştirin.</div>
									) : null}
								</div>
							</div>
							<div className="ac-section">
								<div className="ac-head">
									<div className="ac-title">
										Renkler
										<span className="ac-count">
											{apply_selected.length}/{otherColors ? otherColors.length : 0} seçili
										</span>
									</div>
									{!applying && !apply_done && otherColors && otherColors.length > 1 ? (
										<span className="ac-link" onClick={this.handleApplySelectAll}>
											{apply_selected.length === otherColors.length ? 'Seçimi kaldır' : 'Tümünü seç'}
										</span>
									) : null}
								</div>
								<div className="ac-grid">
									{_.map(otherColors, (it) => {
										let color = _.get(it, 'data.kolaj_editor.text_data.color') || _.get(it, 'data.kolaj_name') || it.id;
										let result = _.find(apply_results, { id: it.id });
										let selected = _.includes(apply_selected, it.id);
										let locked = !!applying || !!apply_done;
										let badge = result ? (result.success ? 'is-ok' : 'is-err') : selected ? 'is-on' : '';
										return (
											<div
												key={it.id}
												className={`ac-card${selected ? ' is-selected' : ' is-off'}${locked ? ' is-locked' : ''}`}
												onClick={() => !locked && this.handleApplySelected(it.id)}
											>
												<img alt={color} src={(it.data.export && it.data.export.url) || (it.data.images && it.data.images[0])} />
												<div className="ac-name">{color}</div>
												<div className={`ac-badge ${badge}`}>
													{result ? <Icon name={result.success ? 'check' : 'close'} /> : selected ? <Icon name="check" /> : null}
												</div>
											</div>
										);
									})}
								</div>
							</div>
							{apply_preview ? (
								<div className="ac-section">
									<div className="ac-head">
										<div className="ac-title">Düzenlenen Kolajın Yeni Hâli</div>
									</div>
									<div className="ac-preview">
										<a href={apply_preview} target="_blank" rel="noopener noreferrer">
											<img alt="preview" src={apply_preview} />
										</a>
									</div>
								</div>
							) : null}
							{apply_error ? <Message negative size="small" style={{ marginTop: '22px' }} content={apply_error} /> : null}
							{_.filter(apply_results, (it) => !it.success).length ? (
								<Message negative size="small" style={{ marginTop: '22px' }}>
									<Message.Header>Başarısız olanlar</Message.Header>
									<Message.List>
										{_.map(
											_.filter(apply_results, (it) => !it.success),
											(it) => (
												<Message.Item key={it.id}>
													{it.name}: {it.error}
												</Message.Item>
											)
										)}
									</Message.List>
								</Message>
							) : null}
							{apply_progress ? (
								<div className="ac-progress">
									<Progress
										value={apply_progress.done}
										total={apply_progress.total}
										progress="ratio"
										color={apply_done ? 'green' : 'blue'}
										active={!!applying}
									>
										{apply_done ? 'Tamamlandı' : 'İşleniyor...'}
									</Progress>
								</div>
							) : null}
							{!apply_done ? (
								<div className="ac-note">
									<Icon name="info circle" />
									<div>
										{apply_preview
											? 'Onayladığında düzenlenen kolaj onaylı (verified) duruma geçer, ardından seçili renkler sırayla kaydedilip yeniden export alınır.'
											: 'Önce düzenlenen kolajın yeni export’u alınır ve önizlenir; onayladıktan sonra seçili renklere uygulanır.'}
									</div>
								</div>
							) : null}
						</div>
					</Modal.Content>
					<Modal.Actions>
						<Button disabled={!!applying} onClick={() => this.closeApplyModal()}>
							{apply_done ? 'Kapat' : 'İptal'}
						</Button>
						{apply_done && _.filter(apply_results, (it) => !it.success).length ? (
							<Button color="orange" loading={!!applying} disabled={!!applying} onClick={() => this.retryFailed()}>
								<Icon name="redo" /> Başarısızları Tekrar Dene ({_.filter(apply_results, (it) => !it.success).length})
							</Button>
						) : null}
						{apply_done ? null : apply_preview ? (
							<Button positive loading={!!applying} disabled={!!applying} onClick={() => this.applyToAllColors()}>
								<Icon name="check" /> Onayla ve Uygula ({apply_selected.length + 1})
							</Button>
						) : (
							<Button
								primary
								loading={!!apply_preview_loading}
								disabled={!!apply_preview_loading || !apply_payload.has_changes}
								onClick={() => this.startApply()}
							>
								Önizle ve Devam Et <Icon name="arrow right" />
							</Button>
						)}
					</Modal.Actions>
				</Modal>
				<Modal
					className="export"
					style={{ width: 'auto' }}
					open={openExportModal}
					size="large"
					onClose={() => this.setState({ openExportModal: false })}
				>
					<Modal.Content style={{ padding: '4px' }}>
						<a href={exportdata.url} target="_blank" rel="noopener noreferrer">
							<Image centered src={exportdata.url} style={{ height: '85vh', width: 'auto' }}></Image>
						</a>
					</Modal.Content>
					<Modal.Actions style={{ display: 'flex' }}>
						<h4>{t('imageVerify')}</h4>
						<Button style={{ marginLeft: 'auto' }} negative onClick={() => this.setState({ openExportModal: false })}>
							{t('no')}
						</Button>
						<Button positive loading={this.state.modalButton} onClick={() => this.exportData(data)}>
							{t('yes')}
						</Button>
					</Modal.Actions>
				</Modal>
			</Page>
		);
	}
}

export default withTranslation()(Folder);
